module.exports = __webpack_public_path__ + "img/bbc_radio_cymru_1.12601e42.png";